<template>
  <router-view :key="reload" />
</template>
<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  setup () {
    const store = useStore();
    const reload = computed(() => store.state.reload);

    return { reload };
  }
};
</script>
